import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelRadio as _vModelRadio, withDirectives as _withDirectives, normalizeClass as _normalizeClass, vModelText as _vModelText, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = { class: "modal-header" };
const _hoisted_2 = { class: "modal-title" };
const _hoisted_3 = { class: "modal-body two-columns" };
const _hoisted_4 = { class: "modal-left" };
const _hoisted_5 = { class: "size-section" };
const _hoisted_6 = ["value", "onChange"];
const _hoisted_7 = { class: "ingredients-section" };
const _hoisted_8 = { class: "search-box" };
const _hoisted_9 = ["placeholder"];
const _hoisted_10 = { class: "ingredients-list" };
const _hoisted_11 = ["onClick"];
const _hoisted_12 = ["src", "alt"];
const _hoisted_13 = { class: "ingredient-name" };
const _hoisted_14 = { class: "ingredient-price" };
const _hoisted_15 = ["onClick"];
const _hoisted_16 = { class: "quantity-section" };
const _hoisted_17 = { class: "quantity-controls" };
const _hoisted_18 = ["disabled"];
const _hoisted_19 = { class: "quantity-display" };
const _hoisted_20 = { class: "modal-right" };
const _hoisted_21 = { class: "summary-section" };
const _hoisted_22 = { class: "summary-line" };
const _hoisted_23 = { class: "summary-line" };
const _hoisted_24 = { class: "summary-ingredients" };
const _hoisted_25 = { key: 0 };
const _hoisted_26 = {
    key: 0,
    class: "no-ingredients"
};
const _hoisted_27 = { class: "summary-line" };
const _hoisted_28 = { class: "summary-total" };
const _hoisted_29 = { class: "price-label" };
const _hoisted_30 = { class: "price-value" };
import { ref, computed, watch } from 'vue';
import CustomPizzaImage from '@/assets/images/products/pate.png';
import { useStore } from 'vuex';
export default /*@__PURE__*/ _defineComponent({
    __name: 'CreatePizzaModal',
    props: {
        visible: { type: Boolean },
        sizes: {},
        ingredients: {},
        allIngredients: {},
        productId: {},
        product: {},
        initialSelectedSize: {}
    },
    emits: ["close", "add-to-cart"],
    setup(__props, { emit: __emit }) {
        const store = useStore();
        const PIZZA_PRODUCT_IDS = {
            CLASSIC: '5a6956b0-2b55-4a46-87a1-57c491cb5b80',
            GLUTEN_FREE: '01b30afb-c735-4dba-bb73-121d1cc7fab2'
        };
        const props = __props;
        const emit = __emit;
        const selectedSizeId = ref('');
        const selectedSize = ref(null);
        const quantity = ref(1);
        const localIngredients = ref([]);
        const selectedIngredients = computed(() => {
            return localIngredients.value.filter(ingredient => ingredient.selected);
        });
        const searchQuery = ref('');
        const filteredIngredients = computed(() => {
            const query = searchQuery.value.toLowerCase().trim();
            if (!query)
                return localIngredients.value;
            return localIngredients.value.filter(ingredient => ingredient.name.toLowerCase().includes(query));
        });
        const availableSizes = computed(() => {
            if (props.product?.productSizes) {
                return props.product.productSizes
                    .filter(size => size.id)
                    .map(size => ({
                    id: size.id,
                    name: size.size,
                    price: size.price || size.takeawayPrice || "0",
                    size: size.size,
                    priceLivraison: size.priceLivraison || size.deliveryPrice || size.price || size.takeawayPrice || "0"
                }))
                    .sort((a, b) => {
                    const order = ["Petite", "Normale", "Grande"];
                    const aIndex = order.indexOf(a.size);
                    const bIndex = order.indexOf(b.size);
                    if (aIndex !== -1 && bIndex !== -1) {
                        return aIndex - bIndex;
                    }
                    if (aIndex !== -1)
                        return -1;
                    if (bIndex !== -1)
                        return 1;
                    return a.size.localeCompare(b.size);
                });
            }
            return props.sizes || [];
        });
        const mapProductSizeToVariationSize = (productSizeName) => {
            const sizeName = productSizeName?.toLowerCase() || "";
            if (sizeName.includes("grande") || sizeName.includes("large") || sizeName.includes("40cm")) {
                return "Grande";
            }
            if (sizeName.includes("normale") || sizeName.includes("normal") || sizeName.includes("petite") || sizeName.includes("small") || sizeName.includes("24cm") || sizeName.includes("33cm")) {
                return "Normale";
            }
            return "unique";
        };
        const getIngredientPriceForSize = (ingredient, productSize = "Normale") => {
            if (!ingredient || !productSize)
                return 0;
            if (ingredient.isDefault === true ||
                ingredient.is_default === true ||
                ingredient.is_default === 1 ||
                ingredient.id?.startsWith("base-")) {
                return 0;
            }
            if (ingredient.price_variations &&
                Array.isArray(ingredient.price_variations)) {
                let variationSize = "unique";
                if (productSize && typeof productSize === "object" && productSize.position !== undefined) {
                    // Priority 1: Map based on position
                    const positionMap = {
                        1: "Normale",
                        2: "Petite",
                        3: "Grande"
                    };
                    variationSize = positionMap[productSize.position] || "unique";
                }
                else if (productSize) {
                    // Priority 2: Fallback to name-based mapping
                    const sizeName = typeof productSize === "string" ? productSize : productSize.name || productSize.size;
                    variationSize = mapProductSizeToVariationSize(sizeName || "Normale");
                }
                let priceVariation = ingredient.price_variations.find((pv) => pv.size?.toLowerCase() === variationSize.toLowerCase());
                if (!priceVariation) {
                    if (variationSize === "Grande") {
                        priceVariation = ingredient.price_variations.find((pv) => pv.size?.toLowerCase() === "normale");
                    }
                    else if (variationSize === "Normale") {
                        priceVariation = ingredient.price_variations.find((pv) => pv.size?.toLowerCase() === "unique");
                    }
                }
                if (!priceVariation && ingredient.price_variations.length > 0) {
                    priceVariation = ingredient.price_variations[0];
                }
                if (priceVariation && typeof priceVariation.price === "number") {
                    return priceVariation.price;
                }
            }
            if (ingredient.extra_cost_price !== undefined) {
                return typeof ingredient.extra_cost_price === "number"
                    ? ingredient.extra_cost_price
                    : parseFloat(ingredient.extra_cost_price) || 0;
            }
            if (ingredient.price !== undefined) {
                return typeof ingredient.price === "number"
                    ? ingredient.price
                    : parseFloat(ingredient.price) || 0;
            }
            return 0;
        };
        watch(() => props.visible, (isVisible) => {
            if (isVisible) {
                const initialSize = props.initialSelectedSize || availableSizes.value[0];
                selectedSize.value = initialSize || null;
                selectedSizeId.value = initialSize?.id || '';
                quantity.value = 1;
                searchQuery.value = '';
                let ingredientsToUse = [];
                if (props.ingredients && props.ingredients.length > 0) {
                    ingredientsToUse = props.ingredients;
                }
                else if (props.allIngredients && props.allIngredients.length > 0) {
                    ingredientsToUse = props.allIngredients.map((ing) => ({
                        id: ing.id,
                        name: ing.name,
                        price: 0,
                        image: ing.image_url || ing.imageUrl || "/images/ingredients/default.png",
                        selected: !!(ing.is_default === true || ing.is_default === 1),
                        price_variations: ing.price_variations || [],
                        type: ing.type,
                        is_default: ing.is_default,
                        extra_cost_price: ing.extra_cost_price
                    }));
                }
                const currentSizeName = selectedSize.value?.name || selectedSize.value?.size || null;
                localIngredients.value = ingredientsToUse.map(ing => {
                    const fullIngredient = props.allIngredients?.find((ai) => ai.id === ing.id) || ing;
                    const price = getIngredientPriceForSize(fullIngredient, selectedSize.value);
                    return {
                        id: ing.id,
                        name: ing.name,
                        price: price,
                        image: ing.image || fullIngredient?.image_url || fullIngredient?.imageUrl || "/images/ingredients/default.png",
                        selected: ing.selected || !!(fullIngredient?.is_default === true || fullIngredient?.is_default === 1) || price === 0,
                        price_variations: fullIngredient?.price_variations || ing.price_variations || []
                    };
                });
            }
        }, { immediate: true });
        watch(() => selectedSize.value, (newSize) => {
            if (newSize && (props.allIngredients || props.ingredients)) {
                const sizeName = newSize.name || newSize.size || null;
                localIngredients.value = localIngredients.value.map(ing => {
                    const fullIngredient = props.allIngredients?.find((ai) => ai.id === ing.id) ||
                        props.ingredients?.find((ai) => ai.id === ing.id);
                    const price = fullIngredient
                        ? getIngredientPriceForSize(fullIngredient, newSize)
                        : ing.price;
                    return {
                        ...ing,
                        price: price
                    };
                });
            }
        });
        const selectSize = (size) => {
            selectedSize.value = size;
            selectedSizeId.value = size.id;
        };
        const toggleIngredient = (index) => {
            localIngredients.value[index].selected = !localIngredients.value[index].selected;
        };
        const incrementQuantity = () => {
            quantity.value++;
        };
        const decrementQuantity = () => {
            if (quantity.value > 1)
                quantity.value--;
        };
        const formatPrice = (price) => `${price.toFixed(2)} CHF`;
        const getSizePrice = (size) => {
            const isDelivery = store.getters['orderType/isDelivery'];
            return isDelivery && size.priceLivraison
                ? parseFloat(size.priceLivraison)
                : parseFloat(size.price);
        };
        const calculateTotal = () => {
            if (!selectedSize.value)
                return 0;
            const isDelivery = store.getters['orderType/isDelivery'];
            const basePrice = isDelivery && selectedSize.value.priceLivraison
                ? parseFloat(selectedSize.value.priceLivraison) || 0
                : parseFloat(selectedSize.value.price) || 0;
            const ingredientsTotal = selectedIngredients.value.reduce((sum, ing) => sum + ing.price, 0);
            return (basePrice + ingredientsTotal) * quantity.value;
        };
        const closeModal = () => emit('close');
        const CUSTOM_PIZZA_IMAGE = CustomPizzaImage;
        const handleAddToCart = () => {
            if (!selectedSize.value)
                return;
            const sizeWithOriginalPrices = {
                ...selectedSize.value,
                price: selectedSize.value.price,
                priceLivraison: selectedSize.value.priceLivraison
            };
            const pizzaName = props.productId === PIZZA_PRODUCT_IDS.GLUTEN_FREE ? 'Votre pizza sans gluten' : 'Votre pizza';
            const productIdToUse = props.productId || PIZZA_PRODUCT_IDS.CLASSIC;
            selectedIngredients.value.forEach(ingredient => {
                const featureName = ingredient.name;
                store.dispatch('features/toggleFeature', featureName);
            });
            const sizeMap = {
                'Petite': '24cm',
                'Normale': '33cm',
                'Grande': '40cm'
            };
            const sizeInCm = selectedSize.value?.name ? sizeMap[selectedSize.value.name] || selectedSize.value.name : '';
            const allCartIngredients = [];
            if (props.allIngredients && props.allIngredients.length > 0) {
                props.allIngredients.forEach((ing) => {
                    if (ing.is_default === true || ing.is_default === 1) {
                        allCartIngredients.push({
                            id: ing.id,
                            name: ing.name,
                            extra_cost_price: 0,
                            quantity: 1,
                            isDefault: true,
                            size: sizeInCm
                        });
                    }
                });
            }
            selectedIngredients.value.forEach(ing => {
                const ingredientInfo = props.allIngredients?.find((i) => i.id === ing.id);
                const isDefault = ingredientInfo?.is_default === true || ingredientInfo?.is_default === 1;
                if (!isDefault) {
                    allCartIngredients.push({
                        id: ing.id,
                        name: ing.name,
                        extra_cost_price: ing.price,
                        quantity: 1,
                        isDefault: false,
                        size: sizeInCm
                    });
                }
            });
            const cartIngredients = allCartIngredients;
            const event = {
                product: {
                    id: productIdToUse,
                    name: pizzaName,
                    description: '',
                    image: CUSTOM_PIZZA_IMAGE,
                    category: 'pizza',
                    sizes: availableSizes.value,
                    ingredients: [],
                    supplements: [],
                    isAvailable: true
                },
                size: sizeWithOriginalPrices,
                quantity: quantity.value,
                ingredients: cartIngredients,
                supplements: [],
                notes: '',
                specification_id: props.product?.id
            };
            emit('add-to-cart', event);
            closeModal();
        };
        return (_ctx, _cache) => {
            return (__props.visible)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "modal-overlay",
                    onClick: closeModal
                }, [
                    _createElementVNode("div", {
                        class: "modal-content",
                        onClick: _cache[3] || (_cache[3] = _withModifiers(() => { }, ["stop"]))
                    }, [
                        _createElementVNode("div", _hoisted_1, [
                            _createElementVNode("h2", _hoisted_2, _toDisplayString(_ctx.$t('pos.createCustomPizza')), 1),
                            _createElementVNode("button", {
                                onClick: closeModal,
                                class: "close-button"
                            }, [...(_cache[4] || (_cache[4] = [
                                    _createElementVNode("i", { class: "fas fa-times" }, null, -1)
                                ]))])
                        ]),
                        _createElementVNode("div", _hoisted_3, [
                            _createElementVNode("div", _hoisted_4, [
                                _createElementVNode("div", _hoisted_5, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(availableSizes.value, (size) => {
                                        return (_openBlock(), _createElementBlock("label", {
                                            key: size.id,
                                            class: _normalizeClass(["size-option", { selected: selectedSize.value?.id === size.id }])
                                        }, [
                                            _withDirectives(_createElementVNode("input", {
                                                type: "radio",
                                                value: size.id,
                                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((selectedSizeId).value = $event)),
                                                onChange: ($event) => (selectSize(size))
                                            }, null, 40, _hoisted_6), [
                                                [_vModelRadio, selectedSizeId.value]
                                            ]),
                                            _createElementVNode("span", null, _toDisplayString(size.name) + " - " + _toDisplayString(formatPrice(getSizePrice(size))), 1)
                                        ], 2));
                                    }), 128))
                                ]),
                                _createElementVNode("div", _hoisted_7, [
                                    _createElementVNode("h4", null, _toDisplayString(_ctx.$t('order.ingredients')), 1),
                                    _createElementVNode("div", _hoisted_8, [
                                        _cache[6] || (_cache[6] = _createElementVNode("i", { class: "fas fa-search search-icon" }, null, -1)),
                                        _withDirectives(_createElementVNode("input", {
                                            type: "text",
                                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((searchQuery).value = $event)),
                                            placeholder: _ctx.$t('pos.searchIngredient'),
                                            class: "search-input"
                                        }, null, 8, _hoisted_9), [
                                            [_vModelText, searchQuery.value]
                                        ]),
                                        (searchQuery.value)
                                            ? (_openBlock(), _createElementBlock("button", {
                                                key: 0,
                                                onClick: _cache[2] || (_cache[2] = ($event) => (searchQuery.value = '')),
                                                class: "clear-search"
                                            }, [...(_cache[5] || (_cache[5] = [
                                                    _createElementVNode("i", { class: "fas fa-times" }, null, -1)
                                                ]))]))
                                            : _createCommentVNode("", true)
                                    ]),
                                    _createElementVNode("div", _hoisted_10, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredIngredients.value, (ingredient, index) => {
                                            return (_openBlock(), _createElementBlock("div", {
                                                key: ingredient.id,
                                                class: _normalizeClass(["ingredient-card", { selected: ingredient.selected }]),
                                                onClick: ($event) => (toggleIngredient(index))
                                            }, [
                                                _createElementVNode("img", {
                                                    src: ingredient.image,
                                                    alt: ingredient.name,
                                                    class: "ingredient-img"
                                                }, null, 8, _hoisted_12),
                                                _createElementVNode("span", _hoisted_13, _toDisplayString(ingredient.name), 1),
                                                _createElementVNode("span", _hoisted_14, "+" + _toDisplayString(formatPrice(ingredient.price)), 1),
                                                _createElementVNode("button", {
                                                    class: "ingredient-toggle",
                                                    onClick: _withModifiers(($event) => (toggleIngredient(index)), ["stop"])
                                                }, [
                                                    _createElementVNode("i", {
                                                        class: _normalizeClass(ingredient.selected ? 'fas fa-check-circle' : 'far fa-circle')
                                                    }, null, 2)
                                                ], 8, _hoisted_15)
                                            ], 10, _hoisted_11));
                                        }), 128))
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_16, [
                                    _createElementVNode("label", null, _toDisplayString(_ctx.$t('common.quantity')) + " :", 1),
                                    _createElementVNode("div", _hoisted_17, [
                                        _createElementVNode("button", {
                                            onClick: decrementQuantity,
                                            disabled: quantity.value <= 1,
                                            class: "quantity-btn"
                                        }, "-", 8, _hoisted_18),
                                        _createElementVNode("span", _hoisted_19, _toDisplayString(quantity.value), 1),
                                        _createElementVNode("button", {
                                            onClick: incrementQuantity,
                                            class: "quantity-btn"
                                        }, "+")
                                    ])
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_20, [
                                _createElementVNode("div", _hoisted_21, [
                                    _createElementVNode("h4", null, _toDisplayString(_ctx.$t('pos.pizzaSummary')), 1),
                                    _createElementVNode("div", _hoisted_22, [
                                        _createElementVNode("strong", null, _toDisplayString(_ctx.$t('pos.sizeLabel')) + " :", 1),
                                        _createTextVNode(" " + _toDisplayString(selectedSize.value?.name), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_23, [
                                        _createElementVNode("strong", null, _toDisplayString(_ctx.$t('order.ingredients')) + " :", 1)
                                    ]),
                                    _createElementVNode("ul", _hoisted_24, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedIngredients.value, (ingredient) => {
                                            return (_openBlock(), _createElementBlock("li", {
                                                key: ingredient.id
                                            }, [
                                                _createTextVNode(_toDisplayString(ingredient.name) + " ", 1),
                                                (ingredient.price > 0)
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_25, "(+" + _toDisplayString(formatPrice(ingredient.price)) + ")", 1))
                                                    : _createCommentVNode("", true)
                                            ]));
                                        }), 128)),
                                        (selectedIngredients.value.length === 0)
                                            ? (_openBlock(), _createElementBlock("li", _hoisted_26, _toDisplayString(_ctx.$t('pos.noIngredientsSelected')), 1))
                                            : _createCommentVNode("", true)
                                    ]),
                                    _createElementVNode("div", _hoisted_27, [
                                        _createElementVNode("strong", null, _toDisplayString(_ctx.$t('common.quantity')) + " :", 1),
                                        _createTextVNode(" " + _toDisplayString(quantity.value), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_28, [
                                        _createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.$t('common.total')) + " :", 1),
                                        _createElementVNode("span", _hoisted_30, _toDisplayString(formatPrice(calculateTotal())), 1)
                                    ]),
                                    _createElementVNode("button", {
                                        onClick: handleAddToCart,
                                        class: "add-to-cart-btn"
                                    }, [
                                        _cache[7] || (_cache[7] = _createElementVNode("i", { class: "fas fa-shopping-cart" }, null, -1)),
                                        _createTextVNode(" " + _toDisplayString(_ctx.$t('pos.addToCart')), 1)
                                    ]),
                                    _createElementVNode("button", {
                                        onClick: closeModal,
                                        class: "cancel-btn"
                                    }, _toDisplayString(_ctx.$t('common.cancel')), 1)
                                ])
                            ])
                        ])
                    ])
                ]))
                : _createCommentVNode("", true);
        };
    }
});
